import React,{ useEffect, useState } from 'react';
import {SearchBar,Page,InfiniteLoader } from 'react-weui';
import { Toast } from 'antd-mobile';

import { getCourseList } from '@/services/home';
import styles from './styles.scss';
import Empty from '@/components/empty';
import { history } from 'umi';


export default (props) => {
  // const categoryId = props.location.state.categoryId;
  // const courseType = props.location.state.courseType;
  // const isHot = props.location.state.isHot;

  const [dataList, setDataList] = useState([]);
  const [searchKey, setSearchKey] = useState('');

  const[pageNo,setPageNo] = useState(1);
  const [totalCount, setTotalCount] = useState(0); // 新增总条数


  useEffect(()=>{
    // document.title = props.location.state.title;

  },[]);



  useEffect(()=>{
    getList(1);
  },[searchKey]);



  function getList(page, resolve, finish) {
    let params = { pageNo: page, pageSize: 20, isHaveMemberOnly: 1 };
    if (searchKey) {
      params.name = searchKey;
    }

    getCourseList(params).then(res => {

      if (res.code == 200) {
        setTotalCount(res.data.count || 0); // 更新总条数
        if (page == 1) {
          setDataList(res.data.list);
        } else {
          setDataList(prev => prev.concat(res.data.list));
        }
        setPageNo(page);
        // 不再用list.length判断finish，由onLoadMore统一判断
        resolve && resolve();
      } else {
       Toast.fail(res.message,1);
        resolve && resolve();
      }
    }).catch(e =>{
      Toast.fail('请求失败，请重试',1);
      resolve && resolve();
    });
  }


  return (
    <Page
      transition={true}
      infiniteLoader={true}
      ptr={false}
      onLoadMore={(resolve, finish) => {
        if (dataList.length >= totalCount && totalCount !== 0) {
          finish();
          return;
        }
        getList(pageNo + 1, resolve, finish);
      }}
      noDataText="没有更多数据了"
    >
      <SearchBar
        navigation
        spaceBetween={50}
        onChange={text => {
          setSearchKey(text);
        }}
        onSubmit={e => {
          console.log('什么也不做', e);
          return false;
        }}
        placeholder={'请输入您想要查询的课程名称或内容'}
      />

      {dataList.length ? (
        dataList.map(item => (
          <div
            className={styles.item_box}
            key={item.id}
            onClick={() => {
              history.push(
                '/home/courseDetail?courseId=' +
                  item.id +
                  '&title=' +
                  item.name,
              );
            }}
          >
            <div className={styles.imgBox}>
              <img className={styles.item_img} src={item.image} />

              {item.type !== '3' && (
                <img
                  className={styles.item_play}
                  src={
                    item.type == '1'
                      ? require('@/assets/ic_play.png')
                      : require('@/assets/music_play.png')
                  }
                />
              )}
            </div>

            <div className={styles.item_content}>
              <label className={styles.item_title}>{item.name}</label>
              <label className={styles.item_subtitle}>{item.intro}</label>
            </div>
          </div>
        ))
      ) : (
        <Empty text={'暂无数据'} />
      )}

      {dataList.length >= totalCount && totalCount !== 0 && (
        <div style={{ textAlign: 'center', color: '#888', padding: '12px 0' }}>
          没有更多数据了
        </div>
      )}
    </Page>
  );
}


